import React, { useState } from 'react';
import { CheckCircle2Icon, PencilLineIcon, UploadCloudIcon } from 'lucide-react';
import { ConfigOverview } from '../components/config/ConfigOverview';
import { SourceList } from '../components/config/SourceList';
import { CadenceEditor } from '../components/config/CadenceEditor';
import { PriorityBuilder } from '../components/config/PriorityBuilder';
import { useAppState } from '../contexts/AppState';
export function Configuration() {
  const {
    draftSources,
    draftPriority,
    setDraftSources,
    setDraftPriority,
    hasDraftChanges,
    lastPublished,
    publishConfiguration,
    discardDraft
  } = useAppState();
  const [selectedId, setSelectedId] = useState(draftSources[0]?.id ?? '');
  const selected = draftSources.find(s => s.id === selectedId) ?? draftSources[0];
  return <div className="space-y-5" data-id="element-402" data-mp="3o8r7c2d626tl">
      <div className="flex flex-wrap items-start justify-between gap-4" data-id="element-403" data-mp="3o90xbpy7odza">
        <div data-id="element-404" data-mp="3j7tsnzrd7uwu">
          <h1 className="text-lg font-semibold tracking-tight text-ink-900" data-id="element-405" data-mp="3j71z0uhbw797">Lead Configuration</h1>
          <p className="mt-0.5 text-sm text-ink-500" data-id="element-406" data-mp="3stwuhu0s5zgn">
            Program how your team works leads — which sources participate, how often to call, and
            what comes first.
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-407" data-mp="3jsfai0k95dmo">
          {hasDraftChanges ? <span className="flex items-center gap-2 rounded-full bg-amber-50 px-3 py-1.5 text-xs font-medium text-amber-800 ring-1 ring-inset ring-amber-100" data-id="element-408" data-mp="3oq8k73krkprp">
              <PencilLineIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-409" data-mp="3eu5ke4ddx37x" />
              Draft changes not published
            </span> : <span className="flex items-center gap-2 rounded-full bg-emerald-50 px-3 py-1.5 text-xs font-medium text-emerald-800 ring-1 ring-inset ring-emerald-100" data-id="element-410" data-mp="3141yxfmbxdjj">
              <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-411" data-mp="2r52rg0davny4" />
              Configuration published
            </span>}
          <button type="button" onClick={discardDraft} disabled={!hasDraftChanges} className="rounded-xl border border-ink-200 px-4 py-2.5 text-sm font-medium text-ink-700 transition-colors hover:bg-ink-50 disabled:cursor-not-allowed disabled:opacity-40" data-id="element-412" data-mp="2w4yvu0pwthe7">
            Discard
          </button>
          <button type="button" onClick={publishConfiguration} disabled={!hasDraftChanges} className="flex items-center gap-2 rounded-xl bg-brand-600 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-brand-700 disabled:cursor-not-allowed disabled:opacity-40" data-id="element-413" data-mp="nwk920r87rli">
            <UploadCloudIcon className="h-4 w-4" aria-hidden="true" data-id="element-414" data-mp="1bn6erldrczsc" />
            Publish Configuration
          </button>
        </div>
      </div>

      <ConfigOverview sources={draftSources} priority={draftPriority} lastPublished={lastPublished} data-id="element-415" data-mp="66pkympj12j" />

      <div className="grid grid-cols-1 gap-5 xl:grid-cols-[320px_minmax(0,1fr)]" data-id="element-416" data-mp="3rawqmpmmvqom">
        <SourceList sources={draftSources} selectedId={selected?.id ?? ''} onSelect={setSelectedId} onToggle={(id, enabled) => setDraftSources(prev => prev.map(s => s.id === id ? {
        ...s,
        enabled
      } : s))} data-id="element-417" data-mp="3h9m09clp3dh2" />
        {selected ? <CadenceEditor source={selected} onChange={rules => setDraftSources(prev => prev.map(s => s.id === selected.id ? {
        ...s,
        rules
      } : s))} data-id="element-418" data-mp="3vyqll2nsdxte" /> : null}
      </div>

      <PriorityBuilder rules={draftPriority} onChange={setDraftPriority} data-id="element-419" data-mp="dsm0r05v0b4x" />
    </div>;
}